export default __webpack_public_path__ + "static/media/Stats_User.fe4197a2.svg";